import React from "react";
import { Container, Row, Col } from "react-bootstrap";
/*import Home2 from "./Home2";*/
import Type from "./Type";
import myImg from "../../Assets/avatar.webp";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Salut! <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
              </h1>

              <h1 className="heading-name">
                Je suis
                <strong className="main-name"> COSSU Médéric</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
            <Col md={3} className="myAvtar">
                    <img src={myImg} className="img-fluid" alt="avatar" />
            </Col>
          </Row>
        </Container>
      </Container>
      {/* <Home2 /> */}
    </section>
  );
}

export default Home;
